/*
 * Modal de historial de audiencia de un conjunto de anuncios (ad_group).
 * Extraído de AudienciasAgente.js para poder abrirse también desde la
 * Matriz por pieza (cada pieza pertenece a un conjunto), sin duplicar el
 * render de las pruebas ni de la comparación antes/después.
 */
import React from 'react'

const TIPOS_AUDIENCIA = [
  { value: 'lookalike', label: 'Lookalike / Similar' },
  { value: 'advantage_plus', label: 'Advantage+ / Amplia' },
  { value: 'interes', label: 'Interés' },
  { value: 'retargeting', label: 'Retargeting / Remarketing' },
  { value: 'otro', label: 'Otro' },
]
const tipoLabel = value => TIPOS_AUDIENCIA.find(t => t.value === value)?.label || value || '—'
const resultadoBadgeClass = value => `am-badge am-badge-${{ positivo: 'verde', negativo: 'rojo', mixto: 'amarillo', pendiente: 'sin_datos' }[value] || 'sin_datos'}`
const origenLabel = value => ({ meta: 'Detectado en Meta', tiktok: 'Detectado en TikTok', manual: 'Manual' }[value] || 'Manual')
const origenBadgeClass = value => value === 'manual' ? 'am-badge-sin_datos' : 'am-badge-verde'
const money = value => value == null ? '—' : `S/ ${Number(value).toFixed(2)}`
const pct = value => value == null ? '—' : `${(Number(value) * 100).toFixed(1)}%`
const num = value => value == null ? '—' : Number(value).toLocaleString('es-PE')

const AudienciaHistorialModal = ({ nombre, rows, onClose }) => (
  <div className="am-modal-backdrop" onClick={onClose}>
    <div className="am-modal-card" onClick={e => e.stopPropagation()}>
      <div className="d-flex justify-content-between"><h5>Historial de audiencia · {nombre}</h5><button className="close" onClick={onClose}>&times;</button></div>
      {(rows || []).length === 0 ? <p className="text-muted">Sin pruebas registradas.</p> : rows.map(row => <div className="am-detail mb-2" key={row.id_prueba}>
        <div className="d-flex justify-content-between flex-wrap">
          <strong>{tipoLabel(row.tipo_audiencia)}{row.tipo_audiencia_detalle ? ` — ${row.tipo_audiencia_detalle}` : ''}</strong>
          <span className={`am-badge ${origenBadgeClass(row.origen)}`}>{origenLabel(row.origen)}</span>
        </div>
        <div className="text-muted">{row.fecha_prueba}{row.id_prueba_referencia ? ` · re-prueba de #${row.id_prueba_referencia}` : ''}</div>
        {row.cambio_detalle && <div><small>{row.cambio_detalle}</small></div>}
        {row.indicador_exito && <div><small>Indicador: {row.indicador_exito}</small></div>}
        <div className="mt-1">
          <span className={resultadoBadgeClass(row.resultado)}>{row.resultado}</span>
          {row.resultado_detalle && <div className="mt-1"><small className={row.resultado === 'pendiente' ? 'text-muted' : ''}>{row.resultado_detalle}</small></div>}
        </div>
        {(row.metricas_antes || row.metricas_despues) && <div className="am-table-wrap mt-2">
          <table className="table table-sm am-table mb-0">
            <thead><tr><th></th><th>Antes</th><th>Después</th></tr></thead>
            <tbody>
              <tr><td>Gasto</td><td>{money(row.metricas_antes?.gasto)}</td><td>{money(row.metricas_despues?.gasto)}</td></tr>
              <tr><td>Leads/día</td><td>{num(row.metricas_antes?.leads_dia)}</td><td>{num(row.metricas_despues?.leads_dia)}</td></tr>
              <tr><td>CPL</td><td>{money(row.metricas_antes?.cpl)}</td><td>{money(row.metricas_despues?.cpl)}</td></tr>
              <tr><td>Tratos</td><td>{num(row.metricas_antes?.tratos)}</td><td>{num(row.metricas_despues?.tratos)}</td></tr>
              <tr><td>Tasa de trato</td><td>{pct(row.metricas_antes?.tasa_trato)}</td><td>{pct(row.metricas_despues?.tasa_trato)}</td></tr>
              <tr><td>Matrículas</td><td>{num(row.metricas_antes?.matriculas)}</td><td>{num(row.metricas_despues?.matriculas)}</td></tr>
              <tr><td>CPA</td><td>{money(row.metricas_antes?.cpa)}</td><td>{money(row.metricas_despues?.cpa)}</td></tr>
            </tbody>
          </table>
        </div>}
      </div>)}
    </div>
  </div>
)

export default AudienciaHistorialModal
